import uploadIcon from 'assets/icons/uploadButtonIcon.svg';
import { Button } from 'primereact/button';
import classes from './UploadExcelButton.module.scss';

const UploadExcelButton = ({ onClick }: { onClick: () => void }) => (
  <Button onClick={onClick} className={classes.button}>
    <img src={uploadIcon} alt="upload" className={classes.btnIcon} />
    <span className={classes.btnTitle}>Upload Excel</span>
  </Button>
);

export default UploadExcelButton;
